export default "https://embed.voomly.com/embed/skin-09.e248112.png";